import { ProcessOrganization } from './process-info';

export class RTProcessInfo {
    rtProcDefId: string;
    flowFormId: string;
    /**
     * 流程组织
     */
    procOrg?: ProcessOrganization;
    /**
     * 访问级别
     */
    accessLevel?: string;
    /**
     * 流程名称
     */
    procName: string;
}
